var map = {
	"./DIZ_project.png": "52cc",
	"./FB11_Biobank_logo.png": "804e",
	"./MII_project.png": "49fa",
	"./dh_distral.png": "7f41",
	"./fdpg_logo.png": "58c4",
	"./miracum_project.png": "8628",
	"./num_project.svg": "a932"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";